var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconD(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5 55C42.6878 55 55 42.6878 55 27.5C55 12.3122 42.6878 0 27.5 0C12.3122 0 0 12.3122 0 27.5C0 42.6878 12.3122 55 27.5 55Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3535 30.6298C33.4491 30.6302 32.5775 30.9724 31.9097 31.5893L28.4331 28.5754V26C28.1303 26.0313 27.8251 26.0313 27.5223 26V28.5754L24.0456 31.5893C22.6256 30.2952 20.4558 30.3401 19.0893 31.6918C17.7228 33.0436 17.6303 35.2368 18.8779 36.7014C20.1255 38.166 22.2836 38.3978 23.8075 37.2308C25.3314 36.0638 25.6962 33.8999 24.6408 32.2881L27.9777 29.3939L31.3145 32.2867C30.3957 33.6964 30.5417 35.5573 31.6688 36.8028C32.7959 38.0483 34.6156 38.3598 36.0851 37.5586C37.5545 36.7575 38.2977 35.0487 37.8886 33.4117C37.4795 31.7748 36.0228 30.6284 34.3535 30.6298Z",
    fill: "#0F53FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 21.5C25 23.433 26.567 25 28.5 25C30.4321 24.9978 31.9978 23.4321 32 21.5C32 19.567 30.433 18 28.5 18C26.567 18 25 19.567 25 21.5ZM25.875 21.5C25.875 20.0503 27.0503 18.875 28.5 18.875C29.9491 18.8764 31.1236 20.0509 31.125 21.5C31.125 22.9497 29.9497 24.125 28.5 24.125C27.0503 24.125 25.875 22.9497 25.875 21.5Z",
    fill: "#0F53FA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconD);
export default __webpack_public_path__ + "static/media/IconD.19f125b0caa94fc886107a4d3eef4c0f.svg";
export { ForwardRef as ReactComponent };